export * from './src/keepalive';
export { NgIdleKeepaliveModule } from './src/module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@ng-idle/keepalive/index.js
// module id = ../../../../@ng-idle/keepalive/index.js
// module chunks = 3